/**
 *  리스트 pagination 모델
 */
export const LIST_PAGINATION_MODEL = {
  pageSize: 100,
  pageNum: 0,
  pages: 1,
};

/**
 *  리스트 summary 모델
 */
export const LIST_SUMMARY_MODEL = {
  totalCnt: null,
};

/**
 *  이미지 아이템 모델
 */
export const IMG_ITEM_MODEL = {
  /**
   *  이미지 식별 ID
   */
  id: null,
  /**
   *  이미지 노출 순서
   */
  no: null,
  /**
   *  이미지 타입
   */
  contentType: null,
  /**
   *  이미지 높이
   */
  height: null,
  /**
   *  이미지 너비
   */
  width: null,
  /**
   *  이미지 URL
   */
  url: null,
  /**
   *  편집 여부
   */
  isEdit: false,
};

/**
 *  리스트 pagination 모델 v2
 */
export const _LIST_PAGINATION_MODEL = {
  pageSize: 20,
  pageNum: 0,
  totalCnt: null,
};
